"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _formatPhoneNumber = _interopRequireDefault(require("I18n/utils/formatPhoneNumber"));

var _formatPhoneNumberWithExtension = _interopRequireDefault(require("I18n/utils/formatPhoneNumberWithExtension"));

var _default = (0, _createReactClass.default)({
  displayName: "FormattedPhoneNumber",
  propTypes: {
    value: _propTypes.default.string.isRequired,
    extension: _propTypes.default.string
  },
  render: function render() {
    var _this$props = this.props,
        value = _this$props.value,
        extension = _this$props.extension,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["value", "extension"]);
    return _react.default.createElement("span", passThroughProps, extension ? (0, _formatPhoneNumberWithExtension.default)(value, extension) : (0, _formatPhoneNumber.default)(value));
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/FormattedPhoneNumber.js
// module id = 827
// module chunks = 209 210 211 212